/* eslint-disable no-unused-vars */
import React from 'react';
import { useParams } from 'react-router-dom';
import { CTitle, STitle } from '../../components/Widget';
// import { useStore } from '../../../../store';
import { useUpdateComponentState } from '../../../hooks';
// import chatBg from '../../../../../../assets/education/topic900/chatBg.png';
import Quiz from '../../components/Quiz';
import person from '../../../../../../assets/education/topic900/person.svg';
import personIcon1 from '../../../../../../assets/education/topic900/priority_icon1.png';
import personIcon2 from '../../../../../../assets/education/topic900/priority_icon2.png';
import personIcon3 from '../../../../../../assets/education/topic900/priority_icon3.svg';
import arrow from '../../../../../../assets/2025/arrow.gif';
// import useIntersectionObserver from '../../../../../../hooks/useIntersectionObserver';
import rightCircle from '../../../../../../assets/education/topic900/right-circle.png';

import step11 from '@/assets/education/topic900/step11.png';
import step2 from '@/assets/education/topic900/step22.png';
import step3 from '@/assets/education/topic900/step3.png';
import step4 from '@/assets/education/topic900/step4.png';

interface ISection3Props {
  settings: any;
}

const stepsPic: any = {
  1: step11,
  2: step2,
  3: step3,
  4: step4,
};

const Section3: React.FunctionComponent<ISection3Props> = ({ settings }) => {
  const ID = '3';
  const param = useParams();
  const p_course = param.course || '';
  const p_topic = param['*'] || 'welcome';

  const paragraphsSettings = React.useMemo(
    () => settings?.paragraphs[2],
    [settings?.paragraphs]
  );

  // 新增：跟踪元素是否已经进入过视口
  // const [hasEntered, setHasEntered] = React.useState(false);
  // 添加步骤状态
  const [currentStep, setCurrentStep] = React.useState(1);

  const [active, setActive] = React.useState(1);
  const [switchTab, setSwitchTab] = React.useState(false);
  const updateComponentState = useUpdateComponentState();

  const [visible, setVisible] = React.useState(2);
  const [animationStarted, setAnimationStarted] = React.useState(false); // 控制动画是否已开始

  const personIcon: any = {
    personIcon1,
    personIcon2,
    personIcon3,
  };

  React.useEffect(() => {
    if (!animationStarted) return;
    if (visible >= paragraphsSettings.l2List?.length) return;
    const timer = setTimeout(() => setVisible((v) => v + 1), 400);
    return () => clearTimeout(timer);
  }, [visible, paragraphsSettings.l2List?.length]);

  const [state, setState] = React.useState({
    clickSlide: 2,
    state1: false,
    quiz: false,
  });

  // 点击箭头图标时触发动画
  const handleArrowClick = () => {
    console.log(11111, animationStarted);
    if (!animationStarted) {
      setAnimationStarted(true);
      setVisible(3); // 从第三条开始显示
      updateComponentState(p_course, p_topic, ID, 'education-ocre-section2-2');
    }
  };

  const clickTab = (n: number) => {
    // 如果已经到达第6个tab，则允许跳转到任意tab
    if (active === 6 || switchTab) {
      setActive(n);
      return;
    }
    // 先依次进行跳转
    if (n === active + 1) {
      setActive(active + 1);
      if (n === 6) {
        setSwitchTab(true);
        setState((prevState) => ({ ...prevState, state1: true }));
        updateComponentState(
          p_course,
          p_topic,
          ID,
          'education-ocre-section2-1'
        );
      }
    }
  };

  const [isLastStep, setIsLastStep] = React.useState(false);
  const [isFirstComplete, setIsFirstComplete] = React.useState(false);

  // 添加步骤切换函数
  const nextStep = () => {
    if (
      paragraphsSettings.stepTextList &&
      currentStep < paragraphsSettings.stepTextList.length
    ) {
      setCurrentStep(currentStep + 1);
    }
    if (currentStep === 3) {
      setIsLastStep(true);
    }
  };

  const entryLinkFn = (link: string) => {
    setIsFirstComplete(true);
    window.open(link, '_blank');
  };

  // 添加后退函数
  const prevStep = () => {
    if (currentStep > 1) {
      setCurrentStep(currentStep - 1);
    }
  };

  const { quiz } = paragraphsSettings;

  // 获取当前步骤的数据
  const currentStepData = paragraphsSettings.stepTextList?.find(
    (item: any) => item.id === currentStep
  );

  return (
    <>
      <i className="back_piece" />
      <div className="t900_custom">
        <div className="topic-section-3">
          {/* 學校網絡安全政策和範本的重要性 */}
          <div
            className="cybersecurity-importance"
            id="education-ocre-section2-1"
          >
            <CTitle title={paragraphsSettings.header} />
            <div className="middle">
              <div className="chat-wrap">
                <p className="chat-text">{paragraphsSettings.description}</p>
              </div>
              <img className="person" src={person} alt="person" />
            </div>

            <nav className="tabs">
              {paragraphsSettings.tabs?.map((n: number, index: number) => (
                <React.Fragment key={n}>
                  {n === active &&
                    index < paragraphsSettings.tabs.length - 1 &&
                    !switchTab && (
                      <div
                        className={`arrow-box ${
                          n === active ? `active-arrow-box${n}` : ''
                        }`}
                        data-active={n === active ? 'true' : 'false'}
                      >
                        <img src={arrow} alt="" />
                      </div>
                    )}
                  <div
                    className={`tab ${n === active ? 'active' : ''}`}
                    onClick={() => clickTab(n)}
                  >
                    {String(n).padStart(2, '0')}
                  </div>
                </React.Fragment>
              ))}
            </nav>
            <div className="tip">{paragraphsSettings.contents[active]}</div>
          </div>

          {/* 學校網絡安全政策包含的内容 */}
          <div className="cybersecurity-policy" id="education-ocre-section2-2">
            {/* 标题 */}
            <STitle title={paragraphsSettings.l2} />

            {/* 内容区 */}
            <div className="content">
              {!animationStarted && (
                <img className="arrow-img" src={arrow} alt="" />
              )}
              <div className="right-list">
                {paragraphsSettings.l2List?.map((txt: string, i: number) => (
                  <div
                    key={i}
                    className="item"
                    data-show={i < visible} // 控制动画
                    onClick={
                      (Number(i) === 0 || Number(i) === 1) && !animationStarted
                        ? handleArrowClick
                        : undefined
                    }
                    style={{
                      cursor:
                        (i === 0 || i === 1) && !animationStarted
                          ? 'pointer'
                          : 'default',
                      position: 'relative',
                      zIndex: i < 2 && !animationStarted ? 10 : 1,
                    }}
                  >
                    <div className="circle">{i + 1}</div>
                    <div className="txt">{txt}</div>
                  </div>
                ))}
              </div>
            </div>
          </div>

          {/* 學校網絡安全政策指定清單優先級 */}
          <div className="cybersecurity-priority">
            <STitle title={paragraphsSettings.l3} />
            <div className="cybersecurity-priority-con">
              <div className="cybersecurity-priority-con-left">
                <div className="con-list">
                  <div className="right-list">
                    {paragraphsSettings.l3List?.map((s: any, i: number) => (
                      <div className="item" key={i}>
                        <img
                          className="left-icon"
                          src={personIcon[s.icon]}
                          alt=""
                        ></img>
                        <div key={i} className="priority-right-text">
                          <div className={`priority-title ${s.bg}`}>
                            {s.title}
                          </div>
                          <div className="priority-subtitle">{s.subtitle}</div>
                          <div className="priority-desc">
                            {paragraphsSettings.l3Unit}
                            <span className="priority-num">{s.desc}</span>
                          </div>
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
              </div>
              <div className="cybersecurity-priority-con-right">
                <div className="text-con">
                  {paragraphsSettings.l3Desc?.map((txt: string, i: number) => (
                    <div className="text-style" key={i}>
                      {txt}
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>

          {/* HKIRC 學校網絡安全政策獲取步驟 */}
          <div className="cybersecurity-step">
            <STitle title={paragraphsSettings.l4} />
            <div className="cybersecurity-step-con">
              {currentStepData && (
                <div key={currentStepData.id}>
                  <div className="cybersecurity-step-link">
                    <div className="step-item-con">
                      <div className="step-img-con">{currentStepData.step}</div>
                      <div className="step-right-con">
                        {/* 前进/后退按钮控制 */}
                        {currentStep > 1 && isLastStep && (
                          <img
                            className="step-img-left-circle"
                            src={rightCircle}
                            alt=""
                            onClick={prevStep}
                            style={{ cursor: 'pointer', marginRight: '1rem' }}
                          />
                        )}
                        {/* {!isLastStep && (
                          <img className="step-img-arrow" src={arrow} alt="" />
                        )} */}
                        {currentStep <
                          (paragraphsSettings.stepTextList?.length || 0) && (
                          <img
                            className="step-img-right-circle"
                            src={rightCircle}
                            alt="前进"
                            onClick={nextStep}
                            style={{ cursor: 'pointer' }}
                          />
                        )}
                      </div>
                    </div>
                    <div className="step-link-text">
                      {currentStepData.label}
                    </div>
                    {currentStepData.id === 1 && (
                      <a
                        className="link"
                        rel="noreferrer"
                        onClick={() => {
                          entryLinkFn(paragraphsSettings.l4Link);
                        }}
                      >
                        {paragraphsSettings.l4Link}
                      </a>
                    )}
                    {/* {currentStepData.id === 1 && !isFirstComplete && (
                      <img className="arrow-gif" src={arrow} alt="" />
                    )} */}
                  </div>
                  <div className="step-pic">
                    <img src={stepsPic[currentStepData.id]} alt="" />
                  </div>
                </div>
              )}
              <div
                id="education-ocre-section2-question"
                className="cybersecurity-quiz"
              >
                <Quiz
                  title={paragraphsSettings?.questionTitle}
                  description={quiz?.description}
                  question={quiz?.question}
                  options={quiz?.options}
                  onCompleted={() => {
                    setState({ ...state, quiz: true });
                    updateComponentState(
                      p_course,
                      p_topic,
                      ID,
                      'education-ocre-section2-question'
                    );
                  }}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
      <i className="bottom_bg" />
    </>
  );
};

export default Section3;
